var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0685 6H12.6262C12.4279 6 12.2656 6.16226 12.2656 6.36058V17.9531C12.2656 18.1514 12.4279 18.3137 12.6262 18.3137H14.0685C14.2668 18.3137 14.4291 18.1514 14.4291 17.9531V6.36058C14.4291 6.16226 14.2668 6 14.0685 6Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59736 6H8.8762C8.67788 6 8.51562 6.16226 8.51562 6.36058V17.9531C8.51562 18.1514 8.67788 18.3137 8.8762 18.3137H9.59736C9.79567 18.3137 9.95793 18.1514 9.95793 17.9531V6.36058C9.95793 6.16226 9.79567 6 9.59736 6Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.268 6H15.9075C15.7091 6 15.5469 6.16226 15.5469 6.36058V17.9531C15.5469 18.1514 15.7091 18.3137 15.9075 18.3137H16.268C16.4663 18.3137 16.6286 18.1514 16.6286 17.9531V6.36058C16.6286 6.16226 16.4663 6 16.268 6Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6394 6H17.8365C17.6382 6 17.476 6.16226 17.476 6.36058V17.9531C17.476 18.1514 17.6382 18.3137 17.8365 18.3137H19.6394C19.8377 18.3137 20 18.1514 20 17.9531V6.36058C20 6.16226 19.8377 6 19.6394 6Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16346 6H5.36058C5.16226 6 5 6.16226 5 6.36058V17.9531C5 18.1514 5.16226 18.3137 5.36058 18.3137H7.16346C7.36178 18.3137 7.52404 18.1514 7.52404 17.9531V6.36058C7.52404 6.16226 7.36178 6 7.16346 6Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVin);
export default __webpack_public_path__ + "static/media/vin.844ee1c76364ed5440274580e63ee55e.svg";
export { ForwardRef as ReactComponent };